document.addEventListener('DOMContentLoaded', () => {
  function inicializarCarruselProducto(modal) {
    // 1. Localizar el elemento del carrusel
    const slideshow = modal.querySelector('[data-product-slideshow]');
    if (!slideshow) return;

    // 2. Leer las opciones personalizadas del atributo data-options, si existen
    let customOptions = {};
    const optionsAttr = slideshow.getAttribute('data-options');
    if (optionsAttr) {
      try {
        customOptions = JSON.parse(decodeURIComponent(optionsAttr));
      } catch (e) {
        console.warn('No se pudieron leer las opciones personalizadas del carrusel:', e);
      }
    }

    // 3. Combinar con las opciones por defecto que usa el tema
    const sliderOptions = {
      autoPlay: false,
      pageDots: false,
      wrapAround: true,
      ...customOptions,
    };

    // 4. Crear una instancia de FlickityFade o Flickity según la opción 'fade'
    // themeVendor.Flickity y themeVendor.FlickityFade están disponibles globalmente cuando theme.js se ha cargado
    const useFade = sliderOptions.fade;
    let flkty;
    if (useFade && window.themeVendor && window.themeVendor.FlickityFade) {
      flkty = new window.themeVendor.FlickityFade(slideshow, sliderOptions);
    } else if (window.themeVendor && window.themeVendor.Flickity) {
      flkty = new window.themeVendor.Flickity(slideshow, sliderOptions);
    } else {
      console.error('Flickity no está disponible.');
      return;
    }

    // 5. Ajustar el carrusel y vincular miniaturas (si existen)
    flkty.resize();
    // Miniaturas
    const thumbLinks = modal.querySelectorAll('[data-thumb-link]');
    thumbLinks.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const idx = parseInt(item.getAttribute('data-thumb-index'), 10) || 0;
        flkty.select(idx);
      });
    });

    // Opcional: actualizar la clase activa de la miniatura cuando cambie la diapositiva
    flkty.on('change', (index) => {
      const activeClass = 'is-active';
      thumbLinks.forEach(link => link.parentElement.classList.remove(activeClass));
      const current = modal.querySelector(`[data-thumb-index="${index}"]`);
      if (current) {
        current.parentElement.classList.add(activeClass);
      }
    });

    // Devuelve la instancia por si necesitas manipularla más adelante
    return flkty;
  }

  function initGlobalTabs(tabsHolder) {
    if (!tabsHolder) return;

    const body = document.body;

    // función para animar elementos con data-aos
    function animateItems(tabContent, animated = true) {
      const items = tabContent.querySelectorAll('[data-aos]');
      items.forEach(item => {
        item.classList.remove('aos-animate');
        if (animated) {
          item.classList.add('aos-no-transition');
          requestAnimationFrame(() => {
            item.classList.remove('aos-no-transition');
            item.classList.add('aos-animate');
          });
        }
      });
    }

    // cambiar pestaña: quita clases "current" y añade al nuevo
    function tabChange(tabNavEl, tabContentEl) {
      if (tabNavEl.classList.contains('current')) return;

      const currentNav = tabsHolder.querySelector('[data-tab].current');
      const currentContent = tabsHolder.querySelector('.tab-content.current');

      currentNav?.classList.remove('current');
      currentContent?.classList.remove('current');

      tabNavEl.classList.add('current');
      tabContentEl.classList.add('current');

      // si el enlace de la pestaña estaba oculto, aplica la misma clase al contenido
      if (tabNavEl.classList.contains('hidden')) {
        tabContentEl.classList.add('hidden');
      }

      // animación de los elementos dentro de la nueva pestaña
      animateItems(tabContentEl);
    }

    // localizar todos los enlaces de pestañas y vincularlos con su contenido
    const tabNavEls = tabsHolder.querySelectorAll('[data-tab]');
    tabNavEls.forEach(navEl => {
      const tabId = navEl.getAttribute('data-tab');
      // el contenido puede identificarse por clase tab-content-{id} o por data-tab-index="{id}"
      let tabContentEl = tabsHolder.querySelector(`.tab-content-${tabId}`);
      if (!tabContentEl) {
        tabContentEl = tabsHolder.querySelector(`.tab-content[data-tab-index="${tabId}"]`);
      }
      if (!tabContentEl) return;

      // evento click para cambiar de pestaña
      navEl.addEventListener('click', () => {
        tabChange(navEl, tabContentEl);
      });

      // evento teclado (Enter o Espacio) para accesibilidad
      navEl.addEventListener('keyup', (event) => {
        const key = event.code;
        if ((key === 'Enter' || key === 'Space') && body.classList.contains('is-focused')) {
          tabChange(navEl, tabContentEl);
        }
      });
    });

    // Opcional: si usas scrollbars nativos en elementos con [data-scrollbar], instáncialos aquí
    const scrollbars = tabsHolder.querySelectorAll('[data-scrollbar]');
    scrollbars.forEach(el => {
      if (window.NativeScrollbar) {
        new window.NativeScrollbar(el);
      }
    });
  }
  
  // Fetch and display product content when quick view triggers are clicked
  async function handleQuickViewClick(event, variantId = false) {
    const trigger = event.target.closest(".quick-view-trigger") ? event.target.closest(".quick-view-trigger") : event.target.closest(".sticky-quick-view__dropdown-item");
    if (!trigger) return;
    event.preventDefault();

    const handle = trigger.dataset.handle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}${variantId ? `?variant=${variantId}` : ''}`);
      const htmlString = await res.text();

      const doc = new DOMParser().parseFromString(htmlString, 'text/html');
      const main = doc.getElementById('MainContent');
      if (!main) throw new Error('No se encontró #MainContent en la respuesta');

      const contentContainer = document.getElementById('product-modal-content');
      contentContainer.innerHTML = '';

      const mainSection = main.querySelector('.main-product-section');
      const stickyQuickViewSection = doc.querySelector('.sticky-quick-view-section');

      if (mainSection) contentContainer.appendChild(mainSection.cloneNode(true));
      if (stickyQuickViewSection) contentContainer.appendChild(stickyQuickViewSection.cloneNode(true));

      if (variantId === false) await openModal();

      inicializarCarruselProducto(contentContainer);
      initGlobalTabs(contentContainer.querySelector('[data-tabs-holder]'));
    } catch (err) {
      console.error('Error loading product modal:', err);
    }
  }

  function openModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.remove("hidden");
    modal.setAttribute("aria-hidden", "false");
    // optionally lock body scroll
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.add("hidden");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    // clean up content for next open (optional)
    document.getElementById("product-modal-content").innerHTML = "";
  }

  // Close modal on overlay or close button click
  document.addEventListener("click", function (event) {
    if (event.target.matches(".quick-view-trigger")) {
      handleQuickViewClick(event);
    } else if (
      event.target.closest(".product-modal__close") ||
      event.target.matches(".product-modal__overlay")
    ) {
      closeModal();
    }
  });

  // Optional: close modal on Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      const modal = document.getElementById("product-modal");
      if (!modal.classList.contains("hidden")) closeModal();
    }
  });

  let variantData = [];
  let selectedOptions = {};

  // Helper to find the sticky quick view element associated with a clicked element
  function findStickyBar(el) {
    return el.closest('.sticky-quick-view');
  }

  // Update variant and UI for a given sticky bar
  function updateVariant(stickyBar, state = false) {
    if (!stickyBar) return;
    let addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
    let priceContainer = addButton && addButton.querySelector('.sticky-quick-view__price');
    if (!addButton || !priceContainer) return;
    variantData = stickyBar.dataset.variantData ? JSON.parse(stickyBar.dataset.variantData) : [];

    // Initialise with the first variant’s options if available
    if (state && variantData.length > 0) {
      variantData[0].options.forEach(function (opt, idx) {
        selectedOptions[idx] = opt;
      });
    } else if (!state && variantData.length > 0) {
      let lstLabels = stickyBar.querySelectorAll('.sticky-quick-view__label');
      lstLabels.forEach((label, idx) => {
        selectedOptions[idx] = label.textContent.trim();
      });
    }
    
    let match = variantData.find(function (variant) {
      return variant.options.every(function (option, idx) {
        return selectedOptions[idx] === option;
      });
    });

    if (match) {
      addButton.dataset.variantId = match.id;
      priceContainer.textContent = '– ' + match.price;
      addButton.disabled = !match.available;
    } else {
      addButton.dataset.variantId = '';
      priceContainer.textContent = '';
      addButton.disabled = true;
    }
  }

  // Delegated click handling for dropdown toggles and items
  document.addEventListener('click', async function (event) {
    if (event.target && event.target.closest('.sticky-quick-view__dropdown-toggle')) {
      let dropdown = event.target.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(event.target);
      if (!dropdown || !stickyBar) return;
      let isOpen = dropdown.classList.contains('is-open');
      // Close any other open dropdowns within this sticky bar
      stickyBar.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('is-open');
          let otherToggle = otherDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
      // Toggle the clicked dropdown
      dropdown.classList.toggle('is-open', !isOpen);
      event.target.closest('.sticky-quick-view__dropdown-toggle').setAttribute('aria-expanded', String(!isOpen));
      event.stopPropagation();
      return;
    } else if (event.target && event.target.closest('.sticky-quick-view__dropdown-item')) {
      let item = event.target.closest('.sticky-quick-view__dropdown-item');
      let value = item.getAttribute('data-value');
      let index = parseInt(item.getAttribute('data-index'), 10);
      let dropdown = item.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(item);
      if (!dropdown || !stickyBar) return;
      // Update selected option state
      selectedOptions[index] = value;
      // Update the toggle’s label and swatch
      let toggleBtn = dropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (toggleBtn) {
        let labelSpan = toggleBtn.querySelector('.sticky-quick-view__label');
        if (labelSpan) labelSpan.textContent = value;
        let swatchSpan = toggleBtn.querySelector('.sticky-quick-view__color-swatch');
        if (swatchSpan && item.dataset.color) {
          swatchSpan.style.backgroundColor = item.dataset.color;
        }
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
      // Close the dropdown
      dropdown.classList.remove('is-open');
      // Update variant and price
      await updateVariant(stickyBar);
      const addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
      if (addButton) handleQuickViewClick(event, addButton.dataset.variantId);
    } else if (event.target && event.target.closest('.sticky-quick-view__add-to-cart')) {
      let addBtn = event.target.closest('.sticky-quick-view__add-to-cart');
      if (addBtn) {
        let variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (response) { return response.json(); })
          .then(async function (data) {
            await document.dispatchEvent(new CustomEvent('theme:product:add', { bubbles: true }));
            await closeModal();
            addBtn.disabled = false;
            if (window.cart?.getCart) {
              window.cart.getCart();
            }
            // const sideCartButton = document.querySelector('.navlink--cart[data-cart-toggle]');
            // if (sideCartButton) sideCartButton.click();
          })
          .catch(function () {
            addBtn.disabled = false;
          });
        event.stopPropagation();
      }
    }
    // Click outside: close all open dropdowns
    document.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (openDropdown) {
      openDropdown.classList.remove('is-open');
      let t = openDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Initialise variant display for any existing sticky bars on load
  document.querySelectorAll('.sticky-quick-view').forEach(function (bar) {
    updateVariant(bar, true);
  });
});